module.exports = __webpack_public_path__ + "static/media/cyan-t.86af468b.svg";